import { LOCAL_STORAGE } from "Components/Constants/LocalStorage";
import { useSelector } from "react-redux";


const DefaultReportMenu = (props) => {
    const user = useSelector((state) => state.auth);
    const { MenuCard } = props;

    return (
        JSON.parse(localStorage.getItem(LOCAL_STORAGE.REPORT_NAVIGATION)).map((menu, index) => (
            <MenuCard key={index} menu={menu} />
        )))
};

export default DefaultReportMenu;
